import { __exports as src } from "../../../../../_virtual/index2.js";
import { __require as requireCookie } from "./cookie.js";
import { __require as requireClient } from "./remote/client.js";
import { __require as requireConfig } from "./types/config.js";
import { __require as requireFactory } from "./factory.js";
import { __require as requireClient$1 } from "./local/client.js";
import { __require as requireLoglevel } from "./types/loglevel.js";
import { __require as requireFetcher } from "./local/fetcher.js";
import { __require as requirePoller } from "./local/poller.js";
import { __require as requireCache } from "./local/cache.js";
var hasRequiredSrc;
function requireSrc() {
  if (hasRequiredSrc) return src;
  hasRequiredSrc = 1;
  (function(exports$1) {
    Object.defineProperty(exports$1, "__esModule", { value: true });
    exports$1.InMemoryFlagConfigCache = exports$1.FlagConfigPoller = exports$1.FlagConfigFetcher = exports$1.LogLevel = exports$1.LocalEvaluationClient = exports$1.Experiment = exports$1.RemoteEvaluationDefaults = exports$1.Defaults = exports$1.RemoteEvaluationClient = exports$1.ExperimentClient = exports$1.AmplitudeCookie = void 0;
    var cookie_1 = requireCookie();
    Object.defineProperty(exports$1, "AmplitudeCookie", { enumerable: true, get: function() {
      return cookie_1.AmplitudeCookie;
    } });
    var client_1 = requireClient();
    Object.defineProperty(exports$1, "ExperimentClient", { enumerable: true, get: function() {
      return client_1.ExperimentClient;
    } });
    Object.defineProperty(exports$1, "RemoteEvaluationClient", { enumerable: true, get: function() {
      return client_1.RemoteEvaluationClient;
    } });
    var config_1 = requireConfig();
    Object.defineProperty(exports$1, "Defaults", { enumerable: true, get: function() {
      return config_1.Defaults;
    } });
    Object.defineProperty(exports$1, "RemoteEvaluationDefaults", { enumerable: true, get: function() {
      return config_1.RemoteEvaluationDefaults;
    } });
    var factory_1 = requireFactory();
    Object.defineProperty(exports$1, "Experiment", { enumerable: true, get: function() {
      return factory_1.Experiment;
    } });
    var client_2 = requireClient$1();
    Object.defineProperty(exports$1, "LocalEvaluationClient", { enumerable: true, get: function() {
      return client_2.LocalEvaluationClient;
    } });
    var loglevel_1 = requireLoglevel();
    Object.defineProperty(exports$1, "LogLevel", { enumerable: true, get: function() {
      return loglevel_1.LogLevel;
    } });
    var fetcher_1 = requireFetcher();
    Object.defineProperty(exports$1, "FlagConfigFetcher", { enumerable: true, get: function() {
      return fetcher_1.FlagConfigFetcher;
    } });
    var poller_1 = requirePoller();
    Object.defineProperty(exports$1, "FlagConfigPoller", { enumerable: true, get: function() {
      return poller_1.FlagConfigPoller;
    } });
    var cache_1 = requireCache();
    Object.defineProperty(exports$1, "InMemoryFlagConfigCache", { enumerable: true, get: function() {
      return cache_1.InMemoryFlagConfigCache;
    } });
  })(src);
  return src;
}
export {
  requireSrc as __require
};
//# sourceMappingURL=index.js.map
